module.exports = {"421087100":"新江口镇","421087101":"南海镇","421087102":"八宝镇","421087103":"涴市镇","421087104":"老城镇","421087105":"陈店镇","421087106":"王家桥镇","421087107":"斯家场镇","421087108":"杨林市镇","421087109":"纸厂河镇","421087110":"街河市镇","421087111":"洈水镇","421087112":"刘家场镇","421087113":"沙道观镇","421087200":"万家乡","421087201":"卸甲坪土家族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421087.json
// module id = 1771
// module chunks = 0